module.exports = __webpack_public_path__ + "static/img/lato-v23-latin-ext_latin-300.54d3cfe.svg";